import React from "react";
import { C, fontStack } from "./theme.js";

/**
 * גבול שגיאה.
 *
 * בלעדיו, חריגה ברכיב אחד מוחקת את כל העץ ומשאירה דף לבן — מסך שנראה
 * זהה לתקלת רשת, לשרת שנפל ולבאג בשורה אחת, ולכן לא ניתן לדווח עליו.
 * כאן לפחות רואים שזו שגיאת תוכנה, ומה היא.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // נשאר בקונסולה עם ה-stack המלא, גם כשהמסך מציג רק את השורה הראשונה.
    console.error("[ui] רכיב קרס:", error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div
        dir="rtl"
        className="min-h-screen w-full flex items-center justify-center px-4 py-10"
        style={{ background: C.surface, color: C.ink, fontFamily: fontStack }}
      >
        <div
          className="w-full max-w-md rounded-2xl border p-6"
          style={{ background: C.card, borderColor: C.line }}
        >
          <h1 className="text-lg font-bold mb-1">משהו נשבר במסך הזה</h1>
          <p className="text-sm mb-3" style={{ color: C.muted }}>
            הנתונים שלך לא נפגעו — התקלה היא בתצוגה בלבד. רענון הדף בדרך כלל
            פותר; אם זה חוזר, זו השורה שכדאי למסור:
          </p>

          <pre
            dir="ltr"
            className="text-[11px] rounded-lg p-3 overflow-x-auto"
            style={{ background: "#F1F4F1", color: C.muted }}
          >
            {String(error?.message || error)}
          </pre>

          <div className="flex gap-2 mt-4">
            <button
              onClick={() => window.location.reload()}
              className="rounded-xl px-4 py-2.5 text-sm"
              style={{ background: C.teal, color: "#fff" }}
            >
              רענון הדף
            </button>
            <button
              onClick={() => this.setState({ error: null })}
              className="rounded-xl px-4 py-2.5 text-sm"
              style={{ border: `1px solid ${C.line}`, color: C.muted }}
            >
              ניסיון נוסף
            </button>
          </div>
        </div>
      </div>
    );
  }
}
